export default "__VITE_ASSET__DKAErgm$__"